import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

const FILTERS = ["Toate", "Bărbați", "Femei", "Unisex"];

export default function ProductsSection() {
  const [products, setProducts] = useState([]);
  const [active, setActive] = useState("Toate");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api.getProducts(active).then((data) => { if (alive) { setProducts(data); setLoading(false); } }).catch(() => setLoading(false));
    return () => { alive = false; };
  }, [active]);

  return (
    <section id="parfumuri" data-testid="products-section" className="relative py-24 lg:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center max-w-2xl mx-auto mb-14">
          <p className="eyebrow text-mocha-dark mb-4">Colecția Signature</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-ink leading-tight">Parfumurile Noastre</h2>
          <p className="text-ink-soft mt-5 leading-relaxed">
            O selecție rafinată de compoziții olfactive, fiecare o operă de artă senzorială.
          </p>
        </Reveal>

        {/* Filters */}
        <div data-testid="category-filters" className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mb-14">
          {FILTERS.map((f) => (
            <button
              key={f}
              data-testid={`filter-${f.replace(/\s+/g, "-").toLowerCase()}`}
              onClick={() => setActive(f)}
              className={`relative px-6 py-2.5 text-xs uppercase tracking-[0.18em] transition-all duration-400 ${
                active === f ? "text-cream" : "text-ink-soft hover:text-ink"
              }`}
            >
              {active === f && (
                <motion.span layoutId="filter-pill" className="absolute inset-0 bg-ink" transition={{ type: "spring", stiffness: 320, damping: 30 }} />
              )}
              <span className="relative z-10" style={active === f ? { textShadow: "0 0 10px rgba(251,246,236,0.9), 0 0 20px rgba(198,158,100,0.5)" } : undefined}>{f}</span>
            </button>
          ))}
        </div>

        {/* Grid */}
        <motion.div layout className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 lg:gap-8">
          <AnimatePresence mode="popLayout">
            {loading
              ? Array.from({ length: 8 }).map((_, i) => (
                  <div key={`skeleton-${i}`} className="aspect-[3/4] bg-beige/60 animate-pulse" />
                ))
              : products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </AnimatePresence>
        </motion.div>

        {!loading && products.length === 0 && (
          <p className="text-center text-ink-muted py-20">Nu există parfumuri în această categorie.</p>
        )}
      </div>
    </section>
  );
}
